import { defineNuxtRouteMiddleware, useNuxtApp } from 'nuxt/app'
import { getMetaFromRoute } from '../utility/route'

interface RouteMeta {
  type?: string
  isSeo?: boolean
  app?: string
}

export default defineNuxtRouteMiddleware((to) => {
  const { $gtm } = useNuxtApp()
  let pageType = ''

  const meta = getMetaFromRoute(to) as RouteMeta
  if (meta.type) {
    switch (meta.type) {
      case 'campsite-details':
        pageType = 'product'
        break
      default:
        pageType = meta.type
    }
  } else {
    switch (to.name) {
      case 'campsite-slug-book':
        pageType = 'booking'
        break
    }
  }

  if (pageType) {
    if ($gtm) {
      $gtm.push({
        page: {
          type: pageType,
        },
      })
    }
  }
})
